"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var elog = require("../../elog");
var classNames = require("classnames");
var react_tracking_1 = require("react-tracking");
var core_link_1 = require("../../components/core_link");
var tracker_1 = require("../../tracker");
var metadata_helper_1 = require("../lib/metadata_helper");
var sanitized_render_1 = require("../../components/sanitized_render");
var COMPONENT_NAME = 'CspSquareCard';
var CspSquareCard = /** @class */ (function (_super) {
    tslib_1.__extends(CspSquareCard, _super);
    function CspSquareCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CspSquareCard.prototype.backgroundStyles = function () {
        var _a;
        if (!this.props.csp) {
            return null;
        }
        return { backgroundImage: "url(" + ((_a = this.props.csp.image) === null || _a === void 0 ? void 0 : _a.source) + ")" };
    };
    CspSquareCard.prototype.priceAndCount = function () {
        var _a = this.props, conditionFilter = _a.conditionFilter, csp = _a.csp;
        var inventory = csp.inventory;
        if (conditionFilter === 'new') {
            var newLowPrice = inventory.newLowPrice, newTotal = inventory.newTotal;
            return { count: newTotal, price: newLowPrice };
        }
        if (conditionFilter === 'used') {
            var usedLowPrice = inventory.usedLowPrice, usedTotal = inventory.usedTotal;
            return { count: usedTotal, price: usedLowPrice };
        }
        var count = inventory.usedTotal + inventory.newTotal;
        if (!inventory.usedLowPrice) {
            return { count: count, price: inventory.newLowPrice };
        }
        if (!inventory.newLowPrice) {
            return { count: count, price: inventory.usedLowPrice };
        }
        if (inventory.newLowPrice.amountCents < inventory.usedLowPrice.amountCents) {
            return { count: count, price: inventory.newLowPrice };
        }
        return { count: count, price: inventory.usedLowPrice };
    };
    CspSquareCard.prototype.renderCalloutLanguage = function () {
        if (!this.props.csp) {
            return null;
        }
        var _a = this.priceAndCount(), price = _a.price, count = _a.count;
        if (!price) {
            elog.error('CSP price is null', {
                inventory: JSON.stringify(this.props.csp.inventory),
                conditionFilter: this.props.conditionFilter,
            }, null);
        }
        if (price.amountCents === 0) {
            return I18n.t('cms.comparisonShoppingPages.priceForFreeHighlightedCount', { count: count, price: price.display, tagOpen: '<b>', tagClose: '</b>' });
        }
        return I18n.t('cms.comparisonShoppingPages.priceFromWithHighlightedCount', { count: count, price: price.display, tagOpen: '<b>', tagClose: '</b>' });
    };
    CspSquareCard.prototype.renderPlaceholderCard = function () {
        return (React.createElement("div", { className: "csp-square-card csp-square-card--placeholder" },
            React.createElement("a", { className: "csp-square-card__inner", href: "#" },
                React.createElement("div", { className: "csp-square-card__main" },
                    React.createElement("div", { className: "csp-square-card__image" })),
                React.createElement("div", { className: "csp-square-card__details" }))));
    };
    CspSquareCard.prototype.webLink = function () {
        if (this.props.conditionFilter === 'new') {
            return this.props.csp.newListingsLink.path;
        }
        if (this.props.conditionFilter === 'used') {
            return this.props.csp.usedListingsLink.path;
        }
        return this.props.csp.webLink.path;
    };
    CspSquareCard.prototype.getDetailsMetadata = function () {
        if (this.props.hideMetadata)
            return;
        return {
            itemScope: true,
            itemProp: 'offers',
            itemType: 'http://schema.org/AggregateOffer',
        };
    };
    CspSquareCard.prototype.getItemMetadata = function () {
        if (this.props.hideMetadata)
            return;
        return {
            itemScope: true,
            itemType: 'http://schema.org/Product',
        };
    };
    CspSquareCard.prototype.renderMetadata = function () {
        if (this.props.hideMetadata)
            return;
        return (React.createElement("div", null,
            React.createElement(metadata_helper_1.BrandMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.NameMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.DescriptionMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.ImageMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.ReviewMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.UrlMetaData, { csp: this.props.csp })));
    };
    CspSquareCard.prototype.renderPriceMetadata = function () {
        if (this.props.hideMetadata)
            return;
        return (React.createElement(metadata_helper_1.PriceMetaData, { csp: this.props.csp, conditionFilter: this.props.conditionFilter }));
    };
    CspSquareCard.prototype.renderTitle = function () {
        return (React.createElement("h3", { className: "csp-square-card__title", itemProp: "model" },
            this.props.csp.title,
            this.renderMetadata()));
    };
    CspSquareCard.prototype.render = function () {
        var classes = classNames('csp-square-card', { 'csp-square-card--horizontal': this.props.renderAsHorizontal });
        try {
            if (!this.props.csp)
                return this.renderPlaceholderCard();
            return (React.createElement("article", tslib_1.__assign({ className: classes }, this.getItemMetadata()),
                React.createElement(core_link_1.default, { className: "csp-square-card__inner", to: this.webLink(), entityId: this.props.csp.id, position: this.props.position },
                    React.createElement("div", { className: "csp-square-card__main" },
                        React.createElement("div", { className: "csp-square-card__image", style: this.backgroundStyles() }),
                        !this.props.renderAsHorizontal && this.renderTitle()),
                    React.createElement("div", { className: "csp-square-card__details" },
                        this.props.renderAsHorizontal && this.renderTitle(),
                        React.createElement("div", tslib_1.__assign({ className: "csp-square-card__details__price" }, this.getDetailsMetadata()),
                            this.renderPriceMetadata(),
                            React.createElement(sanitized_render_1.default, { html: this.renderCalloutLanguage() }))))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CspSquareCard = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                mParticleInteraction: function (data) { return tracker_1.trackCSPClick(data, props.csp, { displayStyle: COMPONENT_NAME }); },
            };
        })
    ], CspSquareCard);
    return CspSquareCard;
}(React.Component));
exports.default = CspSquareCard;
//# sourceMappingURL=csp_square_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/csp_square_card.js
// module id = DnV6
// module chunks = 20 21